import React, { useContext, useReducer, useEffect } from "react";
import { Mobile, Default } from "../../utils/deviceHelpers";
import { Link as DomLink } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { AppContext, CartContext } from "../../utils/stateHandlers/contexts";
import Container from "@mui/material/Container";
import { cartReducer } from "../../utils/stateHandlers/reducers";
import states from "../../utils/stateHandlers/initialStates";
import { storage, api } from "../../utils";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import ShoppingCartSharpIcon from "@mui/icons-material/ShoppingCartSharp";
import PersonIcon from "@mui/icons-material/Person";

export default function Layout(props) {
  let { showFooter, showHeader, user, showMetalMarkets } =
    useContext(AppContext);
  const [cartState, cartDispatch] = useReducer(
    cartReducer,
    states.initialCartState
  );
  const { cartCount } = cartState;

  const loggedIn = storage.getStorageItem("authToken");

  const cartId =
    storage.getStorageItem("cartId") !== "null"
      ? storage.getStorageItem("cartId")
      : JSON.parse(storage.getStorageItem("cartId"));

  useEffect(() => {
    if (loggedIn) {
      api.fetch("cart/check?cart_id=", cartId).then((response) => {
        if (response.isAxiosError) {
          cartDispatch({ type: "setCart", payload: [] });
          cartDispatch({ type: "setCartCount", payload: 0 });
        } else {
          cartDispatch({ type: "setCart", payload: response.data.items });
          cartDispatch({ type: "setCartCount", payload: response.data.count });
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CartContext.Provider value={{ cartState, cartDispatch }}>
      {showHeader && <Header loggedIn={loggedIn} />}
      <Mobile>
        <Container
          maxWidth="100rem"
          sx={
            !showMetalMarkets
              ? { minHeight: "40rem" }
              : { minHeight: "40rem", marginTop: "8rem" }
          }
        >
          {props.children}
        </Container>
      </Mobile>
      <Default>
        <Container
          maxWidth="100rem"
          sx={{ minHeight: "40rem", marginTop: "5rem" }}
        >
          {props.children}
        </Container>
      </Default>
      <Mobile>
        <Paper
          sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}
          elevation={3}
        >
          <Stack
            direction="row"
            spacing={2}
            justifyContent="center"
            alignItems="center"
            sx={{
              paddingBottom: "2rem",
              paddingTop: "2rem",
              backgroundColor: "#f0f0f0",
            }}
          >
            {loggedIn ? (
              <>
                <Link
                  onClick={() => {
                    user.signOut();
                  }}
                  variant="body3"
                  underline="none"
                  className="pointer"
                >
                  <PersonIcon /> LOG OUT
                </Link>
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{ borderColor: "black" }}
                />
                <DomLink
                  to={{
                    pathname: "/account",
                  }}
                >
                  <Typography color="primary" variant="body3" underline="hover">
                    <PersonIcon /> ACCOUNT
                  </Typography>
                </DomLink>
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{ borderColor: "black" }}
                />
                <DomLink
                  to={{
                    pathname: "/cart",
                  }}
                >
                  <Typography color="primary" variant="body3" underline="hover">
                    <ShoppingCartSharpIcon /> CART{" "}
                    {cartCount > 0 && `(${cartCount})`}
                  </Typography>
                </DomLink>
              </>
            ) : (
              <DomLink
                to={{
                  pathname: "/login",
                }}
              >
                <Typography color="primary" variant="body3" underline="hover">
                  <PersonIcon /> LOGIN
                </Typography>
              </DomLink>
            )}
          </Stack>
        </Paper>
      </Mobile>
      {showFooter && <Footer />}
    </CartContext.Provider>
  );
}
